// Loustic Breizh SEO Pages Data
const LICHOU_PAGES = {
  'glace-artisanale-quimper': {
    title: 'Glace Artisanale Quimper | Lait 100% Breton | Loustic Breizh | Finistere',
    description: 'Glace italienne artisanale a Quimper. Lait 100% breton de la Ferme du Vern (Saint-Yvi). Gaufres artisanales, boissons Breizh. Stand present sur les marches et festivals du Finistere de juin a septembre.',
    h1: 'Glace Artisanale a Quimper',
    city: 'Quimper',
    dept: 'Finistere',
  },
  'glace-artisanale-finistere': {
    title: 'Glace Artisanale Finistere | Lait Local Breton | Loustic Breizh | Stand Marches',
    description: 'Stand de glaces italiennes artisanales en Finistere. Lait 100% breton, Ferme du Vern Saint-Yvi. Gaufres bretonnes, boissons Breizh. Marches nocturnes et festivals.',
    h1: 'Glace Artisanale en Finistere',
    city: 'Finistere',
    dept: 'Finistere',
  },
  'glace-italienne-plozevet': {
    title: 'Glace Italienne Plozevet | Plage du Menhir | Lait Breton | Loustic Breizh',
    description: 'Glace italienne artisanale au lait 100% breton sur la plage de Plozevet (Pays Bigouden). Stand Loustic Breizh present du mercredi au dimanche, 14h-19h, des le 1er juillet 2026. Gaufres artisanales et boissons Breizh.',
    h1: 'Glace Italienne a Plozevet (Plage du Menhir)',
    city: 'Plozevet',
    dept: 'Finistere',
  },
  'stand-glace-marche-nocturne-finistere': {
    title: 'Stand Glace Marche Nocturne Finistere | Glace Artisanale Lait Breton | Loustic Breizh',
    description: 'Stand Loustic Breizh de glaces italiennes artisanales sur les marches et plages du Finistere : Plozevet, Quimper, Benodet, Fouesnant. Lait breton Ferme du Vern, gaufres artisanales et boissons Breizh. De juin a septembre.',
    h1: 'Stand Glace Artisanale en Finistere Sud',
    city: 'Finistere',
    dept: 'Finistere',
  },
  'stand-glace-marche-nocturne-morbihan': {
    title: 'Stand Glace Marche Nocturne Morbihan | Glace Artisanale Bretonne | Loustic Breizh',
    description: 'Stand de glaces italiennes artisanales sur les marches nocturnes du Morbihan. Lait 100% breton, gaufres artisanales et boissons Breizh. Loustic Breizh de juin a septembre.',
    h1: 'Stand Glace sur les Marches Nocturnes du Morbihan',
    city: 'Morbihan',
    dept: 'Morbihan',
  },
  'gaufre-artisanale-bretagne': {
    title: 'Gaufre Artisanale Bretagne | Stand Loustic Breizh | Finistere',
    description: 'Gaufres artisanales bretonnes : sucre, confiture, Nuta Breizh, chantilly. Oeufs plein air. Stand Loustic Breizh sur les marches et festivals de Bretagne.',
    h1: 'Gaufres Artisanales Bretonnes',
    city: 'Bretagne',
    dept: 'Finistere et Morbihan',
  },
  'gaufre-caramel-evenement-finistere': {
    title: 'Gaufres Artisanales Evenement Finistere | Stand Loustic Breizh',
    description: 'Gaufres artisanales et boissons Breizh pour vos evenements en Finistere. Stand Loustic Breizh present sur les marches, festivals, kermesses et fetes de juin a septembre.',
    h1: 'Gaufres Artisanales pour Evenements en Finistere',
    city: 'Finistere',
    dept: 'Finistere',
  },
  'stand-ambulant-glace-festival-bretagne': {
    title: 'Stand Ambulant Glace Festival Bretagne ⭐ Lait Breton',
    description: 'Stand ambulant glaces artisanales pour festivals en Bretagne. Lait 100% breton Ferme du Vern, gaufres, boissons Breizh. Disponible juin à septembre en Finistère et Morbihan.',
    h1: 'Stand Ambulant de Glaces pour Festivals en Bretagne',
    city: 'Bretagne',
    dept: 'Finistere et Morbihan',
  },
  'glace-lait-breton-finistere': {
    title: 'Glace au Lait Breton Finistere | Ferme du Vern Saint-Yvi | Loustic Breizh',
    description: 'Glace italienne au lait 100% breton de la Ferme du Vern a Saint-Yvi (Finistere). Fabrication artisanale. Vanille, fraise, mix. Stand Loustic Breizh de juin a septembre.',
    h1: 'Glace au Lait 100% Breton en Finistere',
    city: 'Finistere',
    dept: 'Finistere',
  },
  'glace-artisanale-brest': {
    title: 'Glace Artisanale Brest | Lait Breton | Stand Marche Festival | Loustic Breizh',
    description: 'Glace italienne artisanale a Brest et environs. Lait 100% breton Ferme du Vern. Gaufres et boissons Breizh. Loustic Breizh sur les marches et festivals du Finistere Nord.',
    h1: 'Glace Artisanale a Brest et Environs',
    city: 'Brest',
    dept: 'Finistere',
  },
  'glace-artisanale-concarneau': {
    title: 'Glace Artisanale Concarneau | Lait Breton | Stand Loustic Breizh | Finistere',
    description: 'Glace italienne artisanale a Concarneau. Lait 100% breton de la Ferme du Vern. Stand Loustic Breizh sur les marches et festivals de Concarneau et environs.',
    h1: 'Glace Artisanale a Concarneau',
    city: 'Concarneau',
    dept: 'Finistere',
  },
  'glace-artisanale-lorient': {
    title: 'Glace Artisanale Lorient | Lait Breton | Stand Loustic Breizh | Morbihan',
    description: 'Glace italienne artisanale a Lorient et dans le Morbihan. Lait 100% breton, gaufres artisanales et boissons Breizh. Stand Loustic Breizh de juin a septembre.',
    h1: 'Glace Artisanale a Lorient',
    city: 'Lorient',
    dept: 'Morbihan',
  },
};

const LICHOU_FAQS = [
  { q: 'Ou trouver Loustic Breizh cet ete ?', a: 'Loustic Breizh est present sur les marches nocturnes et festivals du Finistere et Morbihan de juin a septembre. Retrouvez nos dates sur notre page dediee.' },
  { q: 'D\'ou vient le lait de vos glaces ?', a: 'Notre lait provient exclusivement de la Ferme du Vern a Saint-Yvi, dans le Finistere. Un lait 100% breton, frais et local.' },
  { q: 'Quels parfums de glace proposez-vous ?', a: 'Nous proposons de la vanille francaise, de la fraise francaise et un mix fraise-vanille. Tous nos parfums sont fabriques de maniere artisanale.' },
  { q: 'Proposez-vous des gaufres ?', a: 'Oui ! Nos gaufres artisanales sont faites avec des oeufs de poules elevees en plein air. Garnies de sucre, confiture, Nuta Breizh ou chantilly.' },
  { q: 'Peut-on privatiser Loustic Breizh pour un evenement ?', a: 'Oui ! Loustic Breizh se deplace pour vos evenements prives (anniversaires, mariages, fetes). Contactez-nous pour un devis personnalise.' },
  { q: 'Loustic Breizh est-il present toute l\'annee ?', a: 'Non, Loustic Breizh est un stand saisonnier present de juin a septembre sur les marches et evenements en Bretagne.' },
];

export function getLichouPageData(slug) {
  const page = LICHOU_PAGES[slug];
  if (!page) return null;
  return {
    ...page,
    slug,
    canonical: `https://le-clown-magicien.com/${slug}`,
    faqs: LICHOU_FAQS.slice(0, 5),
  };
}

export function getAllLichouSlugs() {
  return Object.keys(LICHOU_PAGES);
}

export { LICHOU_PAGES };
